<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" scrollable>
			<v-card>
				<v-card-title class="text-h6">Form Registrasi Ulang</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-autocomplete item-text="bank_name" item-value="bank_id" outlined dense v-model="params.bank_id" :items="optionBank" label="Bank" no-data-text="Tidak ada data yang sesuai" @focus="() => error_validation.bank_id = ''" :error-messages="error_validation.bank_id"></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Cabang Bank" v-model="params.account_branch" @focus="() => error_validation.account_branch = ''" :error-messages="error_validation.account_branch"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Nama Pemilik Rekening" v-model="params.account_name" @focus="() => error_validation.account_name = ''" :error-messages="error_validation.account_name"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Nomor Rekening" v-model="params.account_no" @focus="() => error_validation.account_no = ''" :error-messages="error_validation.account_no"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
	data () {
		return {
			params: {
				id: '',
				bank_id: '',
				account_branch: '',
				account_name: '',
				account_no: '',
			},
			dialog: false,
		}
	},
	computed: {
		...mapState(['error_validation']),
		...mapState('ecommerceCommon', ['optionBank']),
	},
	methods: {
		...mapMutations(['validationError']),

		showModal() {
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
		},
		defineParams(data) {
			this.validationError({})
			this.params.id = data.stockist_network_id
			this.params.bank_id = data.stockist_bank_bank_id
			this.params.account_branch = data.stockist_bank_account_branch
			this.params.account_name = data.stockist_bank_account_name
			this.params.account_no = data.stockist_bank_account_no
		},
		async simpan(){
			await this.$emit('save', this.params)
		}
	},
	watch: {
	},
	created() {
	}
}
</script>
